var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 544.931,
    height: 388.973,
    viewBox: "0 0 544.931 388.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998",
    transform: "translate(15698 13365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M375.506,360H45a44.421,44.421,0,0,1-19.279-4.51L181,201.211l21.972,21.974a74.343,74.343,0,0,0,24.795,16.447,75.387,75.387,0,0,0,56.466,0,74.339,74.339,0,0,0,24.794-16.447L331,201.211l16.366,16.26a101.4,101.4,0,0,0,9.264,126.6A102.086,102.086,0,0,0,375.5,360Zm-371-25.719v0h0A44.419,44.419,0,0,1,0,315V45A44.421,44.421,0,0,1,4.51,25.721L159.789,180,4.51,334.28ZM256,215.134a44.854,44.854,0,0,1-31.817-13.161L25.721,4.511A44.421,44.421,0,0,1,45,0H467a44.422,44.422,0,0,1,19.279,4.511L287.816,201.973A44.854,44.854,0,0,1,256,215.134Zm256-1.309h0v0a101.961,101.961,0,0,0-35.041-29.345,101.393,101.393,0,0,0-109.11,11.058L352.211,180,507.49,25.721A44.42,44.42,0,0,1,512,45Z",
    transform: "translate(-15698 -13365)",
    fill: "#a94881"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x32_-Magnifying_Glass",
    transform: "translate(-15360.129 -13183.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M203.587,186.868l-38.433-38.433A87.988,87.988,0,0,0,95.139,7.125,88.052,88.052,0,0,0,32.877,157.439a87.863,87.863,0,0,0,115.52,7.755l38.433,38.433a11.849,11.849,0,1,0,16.757-16.757ZM49.634,140.681a64.351,64.351,0,1,1,45.5,18.849A64.431,64.431,0,0,1,49.634,140.681Z",
    transform: "translate(0 0)",
    fill: "#a94881"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add-24px_3_",
    "data-name": "add-24px (3)",
    transform: "translate(-15332 -13154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M0,0H133.644V133.644H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add",
    d: "M76.43,34.468H50.953a1.5,1.5,0,0,1-1.5-1.5V7.493a7.493,7.493,0,0,0-14.986,0V32.97a1.5,1.5,0,0,1-1.5,1.5H7.493a7.493,7.493,0,0,0,0,14.986H32.97a1.5,1.5,0,0,1,1.5,1.5V76.43a7.493,7.493,0,0,0,14.986,0V50.953a1.5,1.5,0,0,1,1.5-1.5H76.43a7.493,7.493,0,0,0,0-14.986Zm0,0",
    transform: "translate(25 24.721)",
    fill: "#a94881"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewMail);
export default __webpack_public_path__ + "static/media/preview-mail.e895f69c.svg";
export { ForwardRef as ReactComponent };